import { render, staticRenderFns } from "./ResponseSummaryItems.vue?vue&type=template&id=160fd670&scoped=true&"
import script from "./ResponseSummaryItems.vue?vue&type=script&lang=js&"
export * from "./ResponseSummaryItems.vue?vue&type=script&lang=js&"
import style0 from "./ResponseSummaryItems.vue?vue&type=style&index=0&id=160fd670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fd670",
  null
  
)

export default component.exports